import { Button, Card, Col, Flex, Modal, Row, Space } from "antd";
import { useTranslation } from "react-i18next";
import { ReactComponent as DownloadIcon } from "../../../assets/icon/downloadIcon.svg";
import { ReactComponent as TextFileIcon } from "../../../assets/icon/textFileIcon.svg";
import { ReactComponent as ExcelIcon } from "../../../assets/icon/excelIcon.svg";

function DocumentSendToBankModal({
    isModalOpen,
    isLoading,
    isTextFileLoading,
    company = {},
    onDocumentModalClose = () => { },
    exportDocForBank = () => { },
    exportDocForBankBLL = () => { },
    exportTextFileBank = () => { }
}) {
    const { t } = useTranslation()

    return (
        <Modal
            title={<span color="#42526D">{t("report.label.download_file")}</span>}
            destroyOnClose
            open={isModalOpen}
            footer={null}
            closable={false}
            maskClosable={false}
        >
            <Space direction="vertical" size={24} style={{ width: "100%" }}>
                <span style={{ fontSize: "14px", color: "#667085" }}>
                    {t("report.modal.description")}
                </span>
                {company?.bankInformation?.bankAccount?.nameEn === "Bangkok Bank Public Company Limited" ?
                    <Card
                        style={{ backgroundColor: "#F5F6F7", border: "1px solid #E4E7EC", borderRadius: "12px" }}
                        styles={{ body: { padding: "16px" } }}
                    >
                        <Row style={{ width: "100%" }}>
                            <Col span={16}>
                                <Flex gap={16} align="center">
                                    <ExcelIcon />
                                    <Flex vertical>
                                        <span style={{ fontWeight: "bold", color: "#42526D" }}>{t("payment.label.doc_bank_BBL")}</span>
                                        <span style={{ color: "#42526D" }}>{t("common.excel_file")}</span>
                                    </Flex>
                                </Flex>
                            </Col>
                            <Col span={8} style={{ alignContent: "center", justifyItems: "self-end" }}>
                                <Button type="default" style={{ height: "40px", borderRadius: "8px", display: "flex", alignItems: "center" }}
                                    onClick={exportDocForBankBLL}
                                    loading={isLoading}
                                    disabled={isLoading}
                                    icon={
                                        !isLoading ? (
                                            <DownloadIcon style={{ fontSize: 16 }} />
                                        ) : (
                                            <span style={{ width: 16, height: 16 }} />
                                        )
                                    }
                                >
                                    <span style={{ color: "#59687F", fontWeight: "bold" }}>{t("common.download")}</span>
                                </Button>
                            </Col>
                        </Row>
                    </Card>
                    : <Card
                        style={{ backgroundColor: "#F5F6F7", border: "1px solid #E4E7EC", borderRadius: "12px" }}
                        styles={{ body: { padding: "16px" } }}
                    >
                        <Row style={{ width: "100%" }}>
                            <Col span={16}>
                                <Flex gap={16} align="center">
                                    <ExcelIcon />
                                    <Flex vertical>
                                        <span style={{ fontWeight: "bold", color: "#42526D" }}>{t("payment.label.doc_bank")}</span>
                                        <span style={{ color: "#42526D" }}>{t("common.excel_file")}</span>
                                    </Flex>
                                </Flex>
                            </Col>
                            <Col span={8} style={{ alignContent: "center", justifyItems: "self-end" }}>
                                <Button type="default" style={{ height: "40px", borderRadius: "8px", display: "flex", alignItems: "center" }}
                                    onClick={exportDocForBank}
                                    loading={isLoading}
                                    disabled={isLoading}
                                    icon={
                                        !isLoading ? (
                                            <DownloadIcon style={{ fontSize: 16 }} />
                                        ) : (
                                            <span style={{ width: 16, height: 16 }} />
                                        )
                                    }
                                >
                                    <span style={{ color: "#59687F", fontWeight: "bold" }}>
                                        {t("common.download")}
                                    </span>
                                </Button>
                            </Col>
                        </Row>
                    </Card>}


                <Card
                    style={{ backgroundColor: "#F5F6F7", border: "1px solid #E4E7EC", borderRadius: "12px" }}
                    styles={{ body: { padding: "16px" } }}
                >
                    <Row style={{ width: "100%" }}>
                        <Col span={16}>
                            <Flex gap={16} align="center">
                                <TextFileIcon />
                                <Flex vertical>
                                    <span style={{ fontWeight: "bold", color: "#42526D" }}>{t("payment.label.text_file")}</span>
                                    <span style={{ color: "#42526D" }}>{t("common.text_file")}</span>
                                </Flex>
                            </Flex>
                        </Col>
                        <Col span={8} style={{ alignContent: "center", justifyItems: "self-end" }}>
                            <Button type="default" style={{ height: "40px", borderRadius: "8px", display: "flex", alignItems: "center" }}
                                onClick={exportTextFileBank}
                                loading={isTextFileLoading}
                                disabled={isTextFileLoading}
                                icon={
                                    !isTextFileLoading ? (
                                        <DownloadIcon style={{ fontSize: 16 }} />
                                    ) : (
                                        <span style={{ width: 16, height: 16 }} />
                                    )
                                }
                            >
                                <span style={{ color: "#59687F", fontWeight: "bold" }}>{t("common.download")}</span>
                            </Button>
                        </Col>
                    </Row>
                </Card>

                <Row justify={"end"}>
                    <Button style={{ borderRadius: "8px", height: "40px" }} type="default" onClick={onDocumentModalClose}>
                        <span style={{ fontWeight: "bold", color: "#344054" }}>{t("common.cancel").toUpperCase()}</span>
                    </Button>
                </Row>
            </Space>
        </Modal>
    )
}

export default DocumentSendToBankModal;